var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{staticClass:"form-control"},_vm._l((_vm.ListaTipoServicio),function(lista,key,index){return _c('option',{key:index,domProps:{"value":lista.IdTipoSer}},[_vm._v(" "+_vm._s(lista.Concepto)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }